<template>
    <HeaderSite :parentMenu="this.$route.name" />
    
    <div>
        <div class="container">
            <div class="row row-cols-1 row-cols-md-3 g-4 my-3">
                <div class="col" v-for="prod in itemProducts" :key="prod.id">
                    <div class="card h-100">
                        <img :src="require(`@/assets/img/${prod.icon}`)" class="card-img-top" />
                        <div class="card-body text-justify">
                            <h5 class="card-title">{{prod.name}}</h5>
                            <p class="card-text">{{prod.shortDesc}}</p>
                            <div class="row">
                                <div class="col-md-12 text-center d-grid">
                                    <!-- <button type="button" class="btn btn-outline-primary btn-sm" @click="$router.push({ name: 'productDetail', params: { id: prod.id } })">More Detail</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center paging mb-5">
                <div class="col-1 text-center m-3" v-if="currentPage > 1">
                    <span class="material-icons fs-1">
                        chevron_left
                    </span>
                </div>
                <div class="col-1 text-center m-3" v-if="currentPage < totalPage">
                    <span class="material-icons fs-1">
                        chevron_right
                    </span>
                </div>
            </div>
        </div>
    </div>
    
    <FooterSite />
    
</template>

<script>
import HeaderSite from '@/components/headerSite.vue';
import FooterSite from '@/components/footerSite.vue';

export default {
    name : 'productPage',
    components : {
        HeaderSite,
        FooterSite
    },
    data(){
        return{
            itemProducts : [],
            currentPage : 0,
            totalPage : 0
        }
    },
    mounted() {
        this.loadProduct();
    },
    methods : {
        loadProduct : function(){

            this.axios
            .get(process.env.VUE_APP_SUBPATH+'data-sample/prods.json')
            .then(response => {
                this.itemProducts = response.data.items;
                this.currentPage = response.data.currentpage;
                this.totalPage = response.data.totalpage;
            })

        }
    }
}
</script>

<style scoped>

.card{
    transition: .6s ease box-shadow;
}
.card:hover{
    box-shadow: 0 0px 15px #dc3545 !important;
    cursor: pointer;
}

.paging div{
    transition: .6s ease;
    border-radius: 3em;
}

.paging div:hover{
    background-color: #efefef;
    cursor: pointer;
}

</style>